import { Link } from "react-router-dom";
import { Instagram, Heart, Sparkles, Music } from "lucide-react";
import { useSettings } from "../lib/settings";

export default function About() {
  const { settings } = useSettings();
  return (
    <div data-testid="about-page" className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
      <div className="text-center">
        <div className="uppercase text-xs tracking-[0.25em] text-[var(--accent)]">About</div>
        <h1 className="mt-4 font-serif text-5xl lg:text-7xl tracking-tight">
          Two brands.<br />One <span className="gold-text italic">love letter</span> to slow living.
        </h1>
      </div>

      <div className="mt-16 grid md:grid-cols-2 gap-10">
        <div className="rounded-3xl overflow-hidden bg-[#F5F2EA] border-2 border-[var(--accent)]/30">
          <img src="https://images.unsplash.com/photo-1592252024957-b0454efe61a3?crop=entropy&cs=srgb&fm=jpg&w=900&q=85"
            alt={settings.brand_name} className="w-full h-80 object-cover" />
          <div className="p-8">
            <div className="flex items-center gap-2 text-[var(--accent)]"><Instagram className="w-4 h-4" /><span className="uppercase text-xs tracking-[0.25em]">{settings.instagram_main}</span></div>
            <h2 className="mt-4 font-serif text-3xl">{settings.brand_name}.</h2>
            <p className="mt-3 text-[#5C5547]">
              The signature brand. Heavyweight tees, ceramic mugs, linen throws, beauty essentials, candles, and the
              small home goods that make a house feel like yours. Made in tiny batches. Always cream, always considered.
            </p>
          </div>
        </div>

        <div className="rounded-3xl overflow-hidden bg-[#F5F2EA] border-2 border-[var(--accent)]/30">
          <img src="https://images.unsplash.com/photo-1518834107812-67b0b7c58434?w=900&q=85"
            alt="Tiny Tunes Dancer" className="w-full h-80 object-cover" />
          <div className="p-8">
            <div className="flex items-center gap-2 text-[var(--accent)]"><Music className="w-4 h-4" /><span className="uppercase text-xs tracking-[0.25em]">{settings.instagram_secondary}</span></div>
            <h2 className="mt-4 font-serif text-3xl">Tiny Tunes Dancer.</h2>
            <p className="mt-3 text-[#5C5547]">
              For the joyful at heart. Tutus, totes, dance journals & soft little merch for the babies, the kids and
              the kid-at-heart. A little corner of pure delight.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-20 text-center">
        <Heart className="w-8 h-8 mx-auto text-[var(--accent)]" />
        <h2 className="mt-4 font-serif text-3xl lg:text-4xl">Why this site exists.</h2>
        <p className="mt-6 max-w-2xl mx-auto text-[#5C5547] leading-relaxed">
          I kept getting DMs asking for "the prompt I used", "the link to that mug", "where to buy that ebook." So I
          built one calm place where you can find everything I make, sell, recommend, and love. No noise. No clutter.
          Just the good stuff.
        </p>
        <Link to="/shop" data-testid="about-shop-cta"
          className="mt-8 inline-block px-7 py-3.5 rounded-full bg-[#2C2924] text-[#FDFBF7] hover:bg-[#1A1815] text-sm">
          Take me to the shop
        </Link>
      </div>
    </div>
  );
}
